function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { CheckCircle } from '@finect/tabular-icons/checkCircle';
import { dataLayer } from '@finect/front-gtm';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { Wrapper, Inner, Info, ResetButton, WrapperActionButton } from './partials';
export var MAX_PRODUCTS = 5;
export var ComparisonDrawer = function (_React$Component) {
  _inherits(ComparisonDrawer, _React$Component);
  var _super = _createSuper(ComparisonDrawer);
  function ComparisonDrawer() {
    var _this;
    _classCallCheck(this, ComparisonDrawer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleCompareAction", function () {
      _this.trackDatalayerCompare();
      _this.props.onAction();
    });
    _defineProperty(_assertThisInitialized(_this), "handleRestoreAction", function () {
      _this.trackDatalayerRestore();
      _this.props.onClear();
    });
    _defineProperty(_assertThisInitialized(_this), "trackDatalayerChange", function () {
      dataLayer({
        id: 'ComparisonDrawer',
        type: 'addProductToComparison',
        params: {
          products: _this.props.products
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "trackDatalayerRestore", function () {
      dataLayer({
        id: 'ComparisonDrawer',
        type: 'restoreProductComparison',
        params: {
          products: _this.props.products
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "trackDatalayerCompare", function () {
      dataLayer({
        id: 'ComparisonDrawer',
        type: 'compareProducts',
        params: {
          products: _this.props.products
        }
      });
    });
    return _this;
  }
  _createClass(ComparisonDrawer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.products.length > 0 && prevProps.products.length !== this.props.products.length) {
        this.trackDatalayerChange();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$products = _this$props.products,
        products = _this$props$products === void 0 ? [] : _this$props$products,
        _this$props$selectedP = _this$props.selectedProductsType,
        selectedProductsType = _this$props$selectedP === void 0 ? null : _this$props$selectedP,
        _this$props$marginBot = _this$props.marginBottom,
        marginBottom = _this$props$marginBot === void 0 ? false : _this$props$marginBot,
        _this$props$position = _this$props.position,
        position = _this$props$position === void 0 ? 'fixed' : _this$props$position;
      return React.createElement(Wrapper, {
        marginBottom: marginBottom,
        position: position
      }, React.createElement(Inner, {
        position: position
      }, React.createElement(WrapperActionButton, null, React.createElement(Button, {
        onClick: this.handleCompareAction,
        variant: "medium",
        disabled: !(products.length > 1),
        width: "auto"
      }, 'Comparar')), React.createElement(Info, null, React.createElement(CheckCircle, null), React.createElement("span", null, products.length, " de ", MAX_PRODUCTS, ' ', selectedProductsType ? getProductTypeLabel(selectedProductsType, 'shortPlural', 'lowercase') : '', ' ', "seleccionados")), React.createElement(ResetButton, {
        onClick: this.handleRestoreAction,
        disabled: !products.length
      }, 'Restablecer')));
    }
  }]);
  return ComparisonDrawer;
}(React.Component);